import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { AxiosPromise } from 'axios'
import { ResponseData } from 'request'
import {
  DemandInfo,
  DemandResult,
  DemandSource,
} from '@pt/api/demand/index.type'

/**
 * getDemandInfo 输入需求id，返回需求的基本信息。
 * @param params {{id: number}}
 * @returns {AxiosPromise}
 */
export function getDemandInfo(params: {
  id: number
}): AxiosPromise<ResponseData<DemandInfo>> {
  return request({
    url: `${v2Host}/demand/query`,
    method: 'get',
    params,
  })
}

/**
 * 根据pt/ps项目id查询提测结果。
 * @param params.source 来源：gm:通用模板，ps:PS项目
 * @param params.project_id 项目ID
 */
export function getDemandResult(params: {
  source: DemandSource
  project_id: number
}): AxiosPromise<ResponseData<DemandResult>> {
  return request({
    url: `${v2Host}/demand/result`,
    method: 'get',
    params,
  })
}

/**
 * 提测/更新基础包/绑定需求
 * @param data.id 需求id
 * @param data.source 来源：gm:通用模板，ps:PS项目
 * @param data.project_id 项目ID
 */
export function submitDemand(data: {
  id: number
  source: DemandSource
  project_id: number
}): AxiosPromise<ResponseData<any>> {
  return request({
    url: `${v2Host}/demand/submit`,
    method: 'post',
    data,
  })
}
